import { render, staticRenderFns } from "./user_billing.vue?vue&type=template&id=45411e6b&scoped=true&"
import script from "./user_billing.vue?vue&type=script&lang=js&"
export * from "./user_billing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45411e6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45411e6b')) {
      api.createRecord('45411e6b', component.options)
    } else {
      api.reload('45411e6b', component.options)
    }
    module.hot.accept("./user_billing.vue?vue&type=template&id=45411e6b&scoped=true&", function () {
      api.rerender('45411e6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/user/profile/tabs/user_billing.vue"
export default component.exports